/**
 * Home feed header date in the viewer's local calendar.
 * Server date_label may use UTC; clients must not display that as-is.
 */
export function formatHomeFeedDateLabel(
  when: Date | string | number | null | undefined = new Date()
): string {
  const date =
    when instanceof Date
      ? when
      : typeof when === 'number'
        ? new Date(when)
        : typeof when === 'string'
          ? new Date(when.includes('T') ? when : when.replace(' ', 'T'))
          : new Date();
  const safe = Number.isNaN(date.getTime()) ? new Date() : date;
  return safe.toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
}

export function clientTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
}
